/*
 * Copyright 2025 coze-dev Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { I18n } from '@coze-arch/i18n';
import { useUrlParams } from '@coze-arch/hooks';
import { renderHtmlTitle } from '@coze-arch/bot-utils';
import { UILayout } from '@coze-arch/bot-semi';

import { ConfirmCard } from './confirm-card';

export const ConsentConfirmPage = () => {
  const {
    value: { confirm_code },
  } = useUrlParams<{ confirm_code: string }>();

  return (
    <UILayout
      title={renderHtmlTitle(I18n.t('plugin_oauth_info_confirm_page'))}
      className="coz-bg-max flex justify-center items-center"
    >
      <ConfirmCard confirmCode={confirm_code} />
    </UILayout>
  );
};
